import type { DashboardAuth } from './authStore';

export type DashboardAuthNormalizationResult =
  | { kind: 'valid'; value: DashboardAuth }
  | { kind: 'invalid' };

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === 'string' && value.length > 0;

const isNullableString = (value: unknown): value is string | null | undefined =>
  typeof value === 'string' || value === null || typeof value === 'undefined';

// Normalizes Core's authentication-shaped responses at the application boundary.
// Core may omit nullable fields at runtime despite generated operation types, so
// validate the required credentials before producing a session the app can store.
export const normalizeDashboardAuth = (payload: unknown): DashboardAuthNormalizationResult => {
  if (!isRecord(payload) || !isNonEmptyString(payload.authJwt) || !isNonEmptyString(payload.agentId)) {
    return { kind: 'invalid' };
  }

  if (!isNullableString(payload.brokerageId)) {
    return { kind: 'invalid' };
  }

  return {
    kind: 'valid',
    value: {
      token: payload.authJwt,
      agentId: payload.agentId,
      brokerageId: payload.brokerageId ?? null,
      role: payload.isBroker === true ? 'broker' : 'agent',
    },
  };
};
